// import AskModal from "../../common/AskModal";
import Modal from "../../common/Modal";
import ProfileSelectionForm from "./ProfileSelectionForm";

const AskProfileSelectModal = ({ visible, onConfirm, onCancel, setImgNumber }) => {

    return (
        <Modal visible={visible} title="Select Profile" description="프로파일을 선택하겠습니까?" onCancel={onCancel} onConfirm={onConfirm} confirmText="Confirm" cancelText="Cancel" >
            <ProfileSelectionForm setImgNumber={setImgNumber} />
        </Modal>
    );
};

export default AskProfileSelectModal;